import { useEffect } from "react";

declare global {
  interface Window {
    hbspt: any;
  }
}

const ContactForm = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "20037605",
          formId: "52930a26-cb1d-4c3f-a775-fe011c6bffa9",
          target: `#hubspotForm`,
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="hubspotForm" />;
};

export default ContactForm;
